import { ValidationErrorMessages } from '@constants/forms';
import { AboutYouFormValues } from '@src/types/yourDetails';
import {
  validateContactNumber,
  validateDob,
  validateEmailAddress,
  validateName,
} from '@utils/validators';

import type { AboutYouFormErrors } from '../types';

const validate = (
  values: AboutYouFormValues,
  isPaperBillingEnabled: boolean
) => {
  const errors: AboutYouFormErrors = {};

  if (!values.aboutNameTitle) {
    errors.aboutNameTitle = ValidationErrorMessages.FIELD_REQUIRED;
  }

  const firstNameError = validateName(values.aboutNameFirst);
  if (firstNameError) {
    errors.aboutNameFirst = firstNameError;
  }

  const lastNameError = validateName(values.aboutNameLast);
  if (lastNameError) {
    errors.aboutNameLast = lastNameError;
  }

  const dobError = validateDob(values.aboutDoB);
  if (dobError) {
    errors.aboutDoB = dobError;
  }

  const contactNumberError = validateContactNumber(values.aboutContactNumber);
  if (contactNumberError) {
    errors.aboutContactNumber = contactNumberError;
  }

  const emailError = validateEmailAddress(
    values.aboutEmail,
    isPaperBillingEnabled
  );
  if (emailError) {
    errors.aboutEmail = emailError;
  }

  return errors;
};

export { validate };
